import React, { useEffect, useState } from "react";
import {
  TableRow,
  TableCell,
  Collapse,
  Box,
  Typography,
  Grid,
  Paper,
  Link,
  Button,
  makeStyles,
  TextField,
  InputAdornment,
  CircularProgress,
  MenuItem,
} from "@material-ui/core";
import PublishIcon from "@material-ui/icons/Publish";
// import FileViewer from "./FileViewer";
import axios from "axios";
import { appUrl } from "../../../../../../../../utils/config";
import { useSelector } from "react-redux";
import moment from "moment";
import FileViewer from "../../../FileViewer";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "16px",
    border: "1px solid #ddd",
  },
  fileLink: {
    display: "flex",
    alignItems: "center",
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  remarks: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  divider: {
    borderTop: "1px solid #ddd",
    margin: theme.spacing(1, 0),
  },
  button: {
    backgroundColor: "#FF9677",
    color: "#fff",
    marginTop: theme.spacing(1),
    "&:hover": {
      backgroundColor: "#FF9677",
    },
  },
}));

const supportingFiles = [
  {
    fileName: "supporting_data.pdf",
    fileLink: "path/to/supporting_data.pdf",
    lastUpdatedDate: "2024-09-27 07:43:30",
  },
];

const ExceptionDocuments = (props) => {
  const { open, exceptionRow, batchData } = props;
  const classes = useStyles();

  const [error, setError] = useState(false);
  const [versionCount, setVersionCount] = useState(null);
  const [latestFile, setLatestFile] = useState(null);
  //   const versionCount = cdmoFileDetails.length;
  //   const latestFile = sponsorFileDetails[sponsorFileDetails.length - 1];

  const [selectedFile, setSelectedFile] = useState(null);
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [cdmoFileDetails, setCdmoFileDetails] = useState([]);
  const [sponsorFileDetails, setSponsorFileDetails] = useState([]);
  const [supportingFiles, setSupportingFileDetails] = useState([]);
  const [approveClicked, setApproveClicked] = useState(false);
  const [recordsFound, setRecordsFound] = useState(true);

  const handleApproveClick = () => {
    setApproveClicked(true);
  };

  useEffect(() => {
    let url = null;

    // const data = {
    //   collabrixWorkItemID: 14316,
    //   collabrixExceptionID: null,
    //   sponsorOrgID: 1,
    //   cdmoOrgID: 2,
    // };
    // const data = {
    //   collabrixWorkItemID: 15329,
    //   collabrixExceptionID: 7830932,
    //   sponsorOrgID: 1,
    //   cdmoOrgID: 2,
    // };
    //   const data ={
    //     collabrixWorkItemID: 14312,
    //     collabrixExceptionID: 9299339,
    //     sponsorOrgID: 1,
    //     cdmoOrgID: 2
    // }
    const data = {
      collabrixWorkItemID: 0, //exceptionRow.collabrixWorkItemID
      eventID: exceptionRow.exceptionID,
      sponsorOrgID: batchData.sponsorOrgID,
      cdmoOrgID: batchData.cdmoOrgID,
    };
    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchDocumentDetails`,
        data
      )
      .then((res) => {
        if (res.data.status) {
          if (
            res.data.data.cdmoFileDetails.length === 0 &&
            res.data.data.sponsorFileDetails.length === 0
          ) {
            setRecordsFound(false);
          }
          const supportingFilteredFiles = res.data.data.cdmoFileDetails.filter(
            (file) => file.fileType === "supporting_file"
          );

          setSupportingFileDetails(supportingFilteredFiles);
          const cdmoScientificFilteredFiles =
            res.data.data.cdmoFileDetails.filter(
              (file) => file.fileType === "scientific_file"
            );
          setCdmoFileDetails(cdmoScientificFilteredFiles);
          const sponsorScientificFilteredFiles =
            res.data.data.sponsorFileDetails.filter(
              (file) => file.fileType === "scientific_file"
            );

          setSponsorFileDetails(sponsorScientificFilteredFiles);
          setVersionCount(res.data.data.cdmoFileDetails.length);
          setLatestFile(
            sponsorScientificFilteredFiles[
              sponsorScientificFilteredFiles.length - 1
            ]
          );
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setError("Something went wrong. Please try again.");
      });

    return () => {
      window.URL.revokeObjectURL(url);
    };
  }, []);

  const handleFileClick = (file) => {
    // Set the clicked file in the state to open the dialog
    //console.log("clicked", file);
    setSelectedFile(file);
    setDialogOpen(true); // Open the dialog when a file is clicked
  };

  const handleCloseDialog = () => {
    setDialogOpen(false); // Close the dialog
  };

  const [remarks, setRemarks] = useState("");

  const handleRemarksChange = (event) => {
    setRemarks(event.target.value);
  };

  const profileDetails = useSelector((state) => state.user.userDetails || {});

  return (
    <>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            {isLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center", // Horizontally center the CircularProgress
                  alignItems: "center", // Vertically center the CircularProgress
                  height: "100px", // Optional: Set a height to vertically center the loader
                }}
              >
                <CircularProgress />
              </div>
            ) : error ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center", // Horizontally center the CircularProgress
                  alignItems: "center", // Vertically center the CircularProgress
                  height: "100px", // Optional: Set a height to vertically center the loader
                  border: "2px solid #FF0000",
                  backgroundColor: "#FFF0F0",
                  width: "100%",
                }}
              >
                <Typography style={{ textAlign: "center" }}>
                  Something went wrong. Please try again.
                </Typography>
              </div>
            ) : recordsFound ? (
              <Box margin={1}>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <Typography variant="h6">
                      {/* {deliverablesData.cdmoOrgName} */}
                    </Typography>
                    <Paper elevation={2} className={classes.paper}>
                      {cdmoFileDetails.map((file, index) => (
                        <React.Fragment key={index}>
                          <Grid container spacing={3}>
                            {/* Version and Date (Left-aligned) */}
                            <Grid item xs={4}>
                              <Typography variant="subtitle1">
                                Version {file.versionNumber}
                              </Typography>
                              <Typography variant="body2" color="textSecondary">
                                {new Date(
                                  file.lastUpdatedDate
                                ).toLocaleString()}
                              </Typography>
                            </Grid>

                            {/* File Name (Right-aligned) */}
                            <Grid item xs={8} className={classes.fileLink}>
                              <PublishIcon className={classes.icon} />
                              <Link
                                href={file.fileLink}
                                target="_blank"
                                rel="noopener"
                                color="secondary"
                                style={{ cursor: "pointer" }}
                                onClick={(e) => {
                                  e.preventDefault(); // Prevent default link action
                                  handleFileClick(file); // Trigger the state change to open the component
                                }}
                              >
                                {file?.fileName ? file.fileName : "-NA-"}
                              </Link>
                            </Grid>
                          </Grid>

                          {/* Remarks (Upload or Resubmission) */}
                          <Grid container spacing={3}>
                            <Grid item xs={4}>
                              {index === 0 && versionCount === 1 ? (
                                <Typography
                                  variant="body2"
                                  className={classes.remarks}
                                >
                                  Upload Remarks:
                                </Typography>
                              ) : index > 0 ? (
                                <Typography
                                  variant="body2"
                                  className={classes.remarks}
                                >
                                  Resubmission Remarks:
                                </Typography>
                              ) : (
                                <Typography
                                  variant="body2"
                                  className={classes.remarks}
                                >
                                  Upload Remarks:
                                </Typography>
                              )}
                            </Grid>
                            <Grid item xs={8}>
                              <Typography
                                variant="body2"
                                className={classes.remarks}
                              >
                                {file?.uploadRemarks
                                  ? file.uploadRemarks
                                  : "NA"}
                              </Typography>
                            </Grid>
                          </Grid>
                        </React.Fragment>
                      ))}

                      {supportingFiles.length > 0 && (
                        <>
                          <Grid container spacing={3}>
                            <Grid xs={12}>
                              <div className={classes.divider}></div>
                            </Grid>
                          </Grid>

                          {/* Supporting Files */}
                          <Grid container spacing={3}>
                            {supportingFiles.map((file, index) => (
                              <>
                                <Grid item xs={4}>
                                  <Typography
                                    variant="subtitle1"
                                    style={{ marginTop: "20px" }} // Added margin for better spacing
                                  >
                                    {index === 0 ? "Supporting Files" : ""}
                                  </Typography>
                                </Grid>

                                <Grid
                                  container
                                  item
                                  xs={8}
                                  key={index}
                                  alignItems="flex-start"
                                  className={classes.fileLink}
                                  style={{ marginTop: "20px" }} // Added margin for better spacing
                                >
                                  {/* File Icon and Name */}
                                  <Grid container alignItems="center">
                                    <PublishIcon className={classes.icon} />
                                    <Link
                                      href={file.fileLink}
                                      target="_blank"
                                      rel="noopener"
                                      style={{
                                        marginRight: "8px",
                                        cursor: "pointer",
                                      }}
                                      color="secondary"
                                      onClick={(e) => {
                                        e.preventDefault(); // Prevent default link action
                                        handleFileClick(file); // Trigger the state change to open the component
                                      }}
                                    >
                                      {file.fileName}
                                    </Link>
                                  </Grid>

                                  {/* Date below the file name */}
                                  <Grid item xs={12}>
                                    <Typography
                                      variant="body2"
                                      color="textSecondary"
                                    >
                                      {new Date(
                                        file.lastUpdatedDate
                                      ).toLocaleString()}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </>
                            ))}
                          </Grid>
                        </>
                      )}
                    </Paper>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography variant="h6">
                      {/* {deliverablesData.sponsorOrgName} */}
                    </Typography>
                    <Paper elevation={2} className={classes.paper}>
                      {sponsorFileDetails.map((file, index) => (
                        <React.Fragment key={index}>
                          <Grid container spacing={3}>
                            {/* Version and Date (Left-aligned) */}
                            <Grid item xs={5}>
                              <Typography variant="subtitle1">
                                Version {file.versionNumber}
                              </Typography>
                              <Typography variant="body2" color="textSecondary">
                                {new Date(
                                  file.lastUpdatedDate
                                ).toLocaleString()}
                              </Typography>
                            </Grid>

                            {/* File Name (Right-aligned) */}
                            <Grid item xs={7} className={classes.fileLink}>
                              <PublishIcon className={classes.icon} />
                              <Link
                                href={file.fileLink}
                                target="_blank"
                                rel="noopener"
                                color="secondary"
                                style={{ cursor: "pointer" }}
                                onClick={(e) => {
                                  e.preventDefault(); // Prevent default link action
                                  handleFileClick(file); // Trigger the state change to open the component
                                }}
                              >
                                {file?.fileName ? file.fileName : "-NA-"}
                              </Link>
                            </Grid>
                          </Grid>

                          {/* Remarks (Upload or Resubmission) */}
                          <Grid container spacing={3}>
                            <Grid item xs={5}>
                              <Typography
                                variant="body2"
                                className={classes.remarks}
                              >
                                Approve / Reject Remarks
                              </Typography>
                            </Grid>
                            <Grid item xs={7}>
                              <Typography
                                variant="body2"
                                className={classes.remarks}
                              >
                                {file.uploadRemarks}
                              </Typography>
                            </Grid>
                          </Grid>
                        </React.Fragment>
                      ))}
                      {exceptionRow?.requireSponsorSMEReview === true && (
                        <Grid
                          container
                          spacing={3}
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Grid item xs={5}>
                            <Typography>Approved By</Typography>
                          </Grid>
                          <Grid item xs={7}>
                            <Typography>
                              {profileDetails.full_name} on{" "}
                              {moment().format("DD-MM-YYYY")}
                            </Typography>
                          </Grid>
                        </Grid>
                      )}

                      <>
                        {exceptionRow?.requireSponsorSMEReview === true &&
                          exceptionRow?.requireSponsorQAReview === true && (
                            <Grid container spacing={3}>
                              <Grid xs={12}>
                                <div className={classes.divider}></div>
                              </Grid>
                            </Grid>
                          )}
                        {exceptionRow?.requireSponsorQAReview === true && (
                          <Grid
                            container
                            spacing={3}
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <Grid item xs={5}>
                              <Typography
                                variant="body2"
                                className={classes.remarks}
                              >
                                QA Approval
                              </Typography>
                            </Grid>
                            <Grid item xs={7}>
                              <Typography
                                variant="body2"
                                className={classes.remarks}
                              >
                                Approved
                              </Typography>
                            </Grid>
                          </Grid>
                        )}
                      </>
                      {/* )} */}

                      {/* </Grid> */}
                    </Paper>
                  </Grid>
                </Grid>
              </Box>
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center", // Horizontally center the CircularProgress
                  alignItems: "center", // Vertically center the CircularProgress
                  height: "100px", // Optional: Set a height to vertically center the loader
                  width: "100%",
                }}
              >
                <Typography style={{ textAlign: "center" }}>
                  No Records Found.
                </Typography>
              </div>
            )}
          </Collapse>
        </TableCell>
      </TableRow>

      {/* deliverablesData, */}
      {isDialogOpen && (
        <FileViewer
          openFileView={isDialogOpen}
          file={selectedFile}
          handleFileViewClose={handleCloseDialog}
          deliverablesData={{ deliverableDescription: [selectedFile.fileName] }}
          sponsorFileDetails={sponsorFileDetails}
          cdmoFileDetails={cdmoFileDetails}
          supportingFiles={supportingFiles}
          sponsorOrgID={batchData.sponsorOrgID}
          cdmoOrgID={batchData.cdmoOrgID}
        />
      )}
    </>
  );
};

export default ExceptionDocuments;
